// extracted by mini-css-extract-plugin
module.exports = {"level":"Footer_level__1poj-","levelRight":"Footer_levelRight__1qbPP"};